import CheckInfoModal from './index.vue';

export default CheckInfoModal;
